import { IGetOfficesCountByStateParams } from '../../types/IGetOfficesCountByStateParams';

export const factoryGetOfficesCountByStateKey = ({
  state,
}: Partial<IGetOfficesCountByStateParams>) =>
  ['GET_OFFICES_COUNT_BY_STATE', state] as const;
